<div class="modal fade" id="loginRegisterModal" tabindex="-1" aria-labelledby="loginRegisterModal" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title my-0" id="loginRegisterModalLabel">{{title}}</h1>
                <button type="button" class="close" id="closeLoginRegisterModal" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form class="" *ngIf="title.toLowerCase()=='register'" [formGroup]="registerForm" (ngSubmit)="register()">
                    <div class="mb-3">
                        <label for="username" class="form-label">Username<span class="text-danger">*</span></label>
                        <input type="text" class="form-control" id="username" formControlName="username" (input)="clearError()">
                    </div>
                    <div class="mb-3">
                        <label for="email" class="form-label">Email address<span class="text-danger">*</span></label>
                        <input type="email" class="form-control" id="email" aria-describedby="emailHelp" formControlName="email" (input)="clearError()">
                        <div id="emailHelp" class="form-text">We'll never share your email with anyone else.</div>
                      </div>
                    <div class="mb-3">
                      <label for="password" class="form-label">Password<span class="text-danger">*</span></label>
                      <input type="password" class="form-control" id="password" formControlName="password" (input)="clearError()">
                    </div>
                    <div class="mb-3">
                        <label for="referrer" class="form-label">Referal code</label>
                        <input type="text" class="form-control" id="referrer" formControlName="referrer" (input)="clearError()" placeholder="(optional)">
                      </div>
                    <!-- <div class="mb-3">
                        <label for="confirmPassword" class="form-label">Confirm Password<span class="text-danger">*</span></label>
                        <input type="password" class="form-control" id="confirmPassword">
                    </div> -->
                    <div class="mb-3 text-center">
                        Already have an account? <span class="text-primary py-2 cursor-pointer" (click)="toggle('Login')">Login</span> instead.
                    </div>
                    <div class="text-center text-success small mb-3" *ngIf="successMailSent">{{mailSentMessage}}</div>
                    <div class="text-center text-danger small mb-3" *ngIf="error">{{errorMessage}}</div>
                    <div class="d-flex justify-content-center">
                        <button type="submit" class="btn btn-primary" [disabled]="registerForm.invalid">{{title}}</button>
                    </div>
                </form>
                <form class="" *ngIf="title.toLowerCase()=='login'" [formGroup]="loginForm" (ngSubmit)="login()">
                    <div class="mb-3">
                        <label for="identifier" class="form-label">Email address<span class="text-danger">*</span></label>
                        <input type="email" class="form-control" id="identifier" formControlName="identifier" (input)="clearError()">
                    </div>
                    <div class="mb-3">
                        <label for="password" class="form-label">Password<span class="text-danger">*</span></label>
                        <input type="password" class="form-control" id="password" formControlName="password" (input)="clearError()">
                        
                    </div>
                    <div class="mb-3 text-center">
                        New to Bitssa? <span class="text-primary py-2 cursor-pointer" (click)="toggle('Register')">Register</span> instead.
                    </div>
                    <div class="mb-3 text-center">
                        Forgot password? <span class="text-primary py-2 cursor-pointer" (click)="toggle('Reset')">Click here</span> to reset.
                    </div>
                    <div class="text-center text-danger small mb-3" *ngIf="error">{{errorMessage}}</div>
                    <div class="d-flex justify-content-center">
                        <button type="submit" class="btn btn-primary" [disabled]="loginForm.invalid">{{title}}</button>
                    </div>
                </form>
                <form class="" *ngIf="title.toLowerCase()=='reset'" [formGroup]="forgotPasswordForm" (ngSubmit)="forgotPassword()">
                    <div class="mb-3">
                        <label for="email" class="form-label">Email address<span class="text-danger">*</span></label>
                        <input type="email" class="form-control" id="email" formControlName="email" (input)="clearError()">
                    </div>
                    <div class="mb-3 text-center">
                        Wanna try with different account? <span class="text-primary py-2 cursor-pointer" (click)="toggle('Login')">Login</span> instead.
                    </div>
                    <div class="text-center text-success small mb-3" *ngIf="successMailSent">{{mailSentMessage}}</div>
                    <div class="text-center text-danger small mb-3" *ngIf="error">{{errorMessage}}</div>
                    <div class="d-flex justify-content-center">
                        <button type="submit" class="btn btn-primary" [disabled]="forgotPasswordForm.invalid">{{title}}</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

